module.exports = __webpack_public_path__ + "static/media/3-3.9b279828.mp3";